"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function getEntitlementSpidProductCode(clientShortHandName, isProduction) {
    if (isProduction === void 0) { isProduction = false; }
    var prodProductIds = function (client) {
        var _a;
        return ((_a = {},
            _a[types_1.ClientShortHandName.DP] = {
                '301879': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: [
                        "M0D",
                        "M1D",
                        "M2D",
                        "M3D",
                        "M4D",
                        "M5D",
                        "M6D",
                        "M7D",
                        "M0P",
                        "M1P",
                        "M2P",
                        "M3P",
                        "M4P",
                        "M5P",
                        "M6P",
                        "M7P",
                        "M0DD",
                        "M0DS",
                        "M0DF"
                    ],
                },
                '301881': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: [
                        "M0D",
                        "M1D",
                        "M2D",
                        "M3D",
                        "M4D",
                        "M5D",
                        "M6D",
                        "M0P",
                        "M1P",
                        "M2P",
                        "M3P",
                        "M4P",
                        "M5P",
                        "M6P",
                        "M0PF",
                        "M1PF",
                        "M2PF",
                        "M3PF",
                        "M4PF",
                        "M5PF",
                        "M6PF",
                    ],
                },
                '301880': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: [
                        "M0P",
                        "M1P",
                        "M2P",
                        "M3P",
                        "M4P",
                        "M5P",
                        "M6P",
                        "M1D",
                        "M2D",
                        "M3D",
                        "M4D",
                        "M5D",
                        "M6D",
                        "M7D",
                    ],
                },
                'FEA-E24-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-E24-PLUSARTICLES"]
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-E24-PLUSARTICLES"]
                },
                '301899': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '301415': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301966': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301964': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
            },
            _a[types_1.ClientShortHandName.VG] = {
                'FEA-E24-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-E24-PLUSARTICLES"]
                },
                'FEA-PRINT': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: ["VG_EAVIS"],
                    bundleCodes: ["FEA-PRINT"]
                },
                'FEA-VG-EPAPER': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-VG-EPAPER"]
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-VG-PLUSARTICLES"]
                },
                'FEA-VG-SPORT': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-VG-SPORT"]
                },
                '301899': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '301415': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301966': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301964': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301809': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
            },
            _a[types_1.ClientShortHandName.AP] = {
                '301963': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0VINK"],
                },
                '301897': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["NYHSEKS"],
                },
                '301898': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["NYHKLA"],
                },
                '301899': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '301966': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301964': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301809': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["AP-BASIC"],
                }
            },
            _a[types_1.ClientShortHandName.BTI] = {
                '301899': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '301415': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301966': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301809': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["BT-BASIC"],
                }
            },
            _a[types_1.ClientShortHandName.SA] = {
                '301899': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '301415': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301964': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '301809': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["SA-BASIC"],
                }
            },
            _a)[client]);
    };
    var testProductIds = function (client) {
        var _a;
        return ((_a = {},
            _a[types_1.ClientShortHandName.DP] = {
                '303111': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: [
                        "M0D",
                        "M1D",
                        "M2D",
                        "M3D",
                        "M4D",
                        "M5D",
                        "M6D",
                        "M7D",
                        "M0P",
                        "M1P",
                        "M2P",
                        "M3P",
                        "M4P",
                        "M5P",
                        "M6P",
                        "M7P",
                        "M0DD",
                        "M0DS",
                        "M0DF"
                    ],
                },
                '303112': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: [
                        "M0D",
                        "M1D",
                        "M2D",
                        "M3D",
                        "M4D",
                        "M5D",
                        "M6D",
                        "M0P",
                        "M1P",
                        "M2P",
                        "M3P",
                        "M4P",
                        "M5P",
                        "M6P",
                        "M0PF",
                        "M1PF",
                        "M2PF",
                        "M3PF",
                        "M4PF",
                        "M5PF",
                        "M6PF",
                    ],
                },
                '303113': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: [
                        "M0P",
                        "M1P",
                        "M2P",
                        "M3P",
                        "M4P",
                        "M5P",
                        "M6P",
                        "M1D",
                        "M2D",
                        "M3D",
                        "M4D",
                        "M5D",
                        "M6D",
                        "M7D",
                    ],
                },
                'FEA-E24-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-E24-PLUSARTICLES"]
                },
                '303129': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '303117': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303170': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303168': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-E24-PLUSARTICLES"]
                },
            },
            _a[types_1.ClientShortHandName.VG] = {
                'FEA-E24-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-E24-PLUSARTICLES"]
                },
                'FEA-PRINT': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-PRINT"]
                },
                'FEA-VG-EPAPER': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-VG-EPAPER"]
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["FEA-VG-PLUSARTICLES"]
                },
                'FEA-VG-SPORT': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["VG_PLUSS_SPORT"]
                },
                '303129': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '303117': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303170': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303168': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303030': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
            },
            _a[types_1.ClientShortHandName.AP] = {
                '303167': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0VINK"],
                },
                '303123': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["NYHSEKS"],
                },
                '303125': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["NYHKLA"],
                },
                '303129': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '303170': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303168': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303030': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["AP-BASIC"],
                }
            },
            _a[types_1.ClientShortHandName.BTI] = {
                '303129': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '303117': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303170': {
                    client: types_1.ClientShortHandName.SA,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303030': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["BT-BASIC"],
                }
            },
            _a[types_1.ClientShortHandName.SA] = {
                '303129': {
                    client: types_1.ClientShortHandName.SCH,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0PB"],
                },
                '303117': {
                    client: types_1.ClientShortHandName.AP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303168': {
                    client: types_1.ClientShortHandName.BTI,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                '303030': {
                    client: types_1.ClientShortHandName.DP,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["M0DA", "M1DA", "M2DA", "M3DA", "M4DA", "M5DA", "M6DA"],
                },
                'FEA-VG-PLUSARTICLES': {
                    client: types_1.ClientShortHandName.VG,
                    superSetOfBundleCodes: [],
                    bundleCodes: ["SA-BASIC"],
                }
            },
            _a)[client]);
    };
    return isProduction
        ? prodProductIds(clientShortHandName)
        : testProductIds(clientShortHandName);
}
exports.default = getEntitlementSpidProductCode;
//# sourceMappingURL=getEntitlementSpidProductCode.js.map